import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledNoResultsEmpty } from './NoResultsEmpty.styles';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';

export const NoResultsEmpty = (): React.JSX.Element => {
  const { t } = useTranslation();
  return (
    <StyledNoResultsEmpty className="no-results-empty">
      <span aria-hidden="true">
        <SvgIcon name="statistics" className="no-results-empty__icon" />
      </span>
      <span className="no-results-empty__title">{t('machineDashboard.noResults')}</span>
      <span className="no-results-empty__description">{t('machineDashboard.noResultsDescription')}</span>
    </StyledNoResultsEmpty>
  );
};
